module.exports = __webpack_public_path__ + "static/front-page-04-7a2d6023fcedc1740b6a668499c7b585.jpg";